import React, { useState } from 'react';
import { Rate, Spin, Divider } from 'antd';
import PropTypes from 'prop-types';

import Client from 'containers/app/client';
import { useUserWithRole } from 'hooks/custom-auth';

import './style.css';

const BookingRequestRate = ({ id, request, status }) => {
  const [user, loading, error] = useUserWithRole(Client.auth);
  const [loadingRate, setLoadingRate] = useState(false);

  if (loading) return <Spin />;
  if (error) throw error;

  const { role } = user.claims;
  const isWorker = role === 'isWorker';

  if (status !== 'expired') return null;

  const { gradeWorker = 0, gradeEmployer = 0 } = request;

  const handleRate = async (value) => {
    try {
      const data = isWorker ? { gradeEmployer: value } : { gradeWorker : value };

      setLoadingRate(true);
      await Client.db.doc(`bookings/${id}`).set(data, { merge: true });
      setLoadingRate(false);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <Divider />
      <section className="booking-detail-section -rate">
        <h2>Rate the shift</h2>
        {loadingRate ? (
          <div className="ant-rate">
            <Spin />
          </div>
        ) : (
          <Rate value={isWorker ?  gradeEmployer : gradeWorker} onChange={handleRate} />
        )}
      </section>
    </>
  );
};

BookingRequestRate.propTypes = {
  id: PropTypes.string.isRequired,
  request: PropTypes.shape({
    userId: PropTypes.string,
    grade: PropTypes.number,
  }).isRequired,
  status: PropTypes.string.isRequired,
};

export default BookingRequestRate;
